import { MarriageLesson } from '../types';

export const marriageLessons: MarriageLesson[] = [
  {
    id: 'lets-talk-love',
    title: "Let's Talk Love",
    description: 'Love Talk: Lesson 5',
    duration: '45 minutes',
    imageUrl:
      'https://vhx.imgix.net/studygateway/assets/edb80378-0529-4c83-afa4-276410d2d23c.jpg?auto=format%2Ccompress&fit=crop&h=720&q=75&w=1280',
    objectives: [],
    scriptureReferences: ['PROVERBS 12:25'],
    category: 'Intimacy',
    content: `
      <div class="lesson-content">
        <div class="intro-section">
          <h2>Love Talk: Lesson 5 - Let's Talk Love</h2>
          

        </div>

        <div class="handout-section">
          <h2>📝 Discussion Questions</h2>
          <p><strong>Instructions:</strong> After watching the video, complete this handout together with your spouse.</p>
          
          <div class="questions-list">
            <ol>
                <li>Generally speaking, would you say your self-talk is more positive or negative? What effect do you think it has on you and your marriage?
                </li>
                <li>
                In what ways has your relationship with God affected the way you think about yourself and your spouse? What difference does God’s grace and love have on your self-talk?
                </li>
                <li>
                In the story, what led to Jonas and Anne’s reconciliation? In what ways did they renew their commitment to one another?
                </li>
                <li>
                What does it look like to accept positive affirmation from your spouse? What could you do to help yourself avoid allowing negative words to stick?
                </li>
                <li>
                Looking back over this study, what’s one thing you could do this week to be a better husband or wife?
                </li>
                <h3>📖 READ PROVERBS 12:25</h3>
                <li>
               In what ways have you experienced the weight of anxiety? What does your self-talk sound like when you’re feeling anxious?
                </li>
                <li>
                What does it look like to speak kindly to yourself? What kind of an effect does it have on your attitude towards yourself?
                </li>
                <li>
                What, if anything, intimidates you about voicing your self-talk to your spouse? What could it look like to talk about it with your spouse this week?
                </li>
            </ol>
          </div>
        </div>

        <div class="closing-section">

          
          <div class="prayer-section">

          <p><b>APPLY WHAT YOU’VE LEARNED</b></p>
          <p>Select an activity from the list below to begin applying
          the lessons of this session to your life.</p>
          <p><b>Pray:</b> Pray with your spouse this week about what you
          learned through this study. Ask God to solidify the
          wisdom you gathered through Love Talk and pray for
          ways to apply the truths you learned in your marriage.</p>

          <p><b>Practice:</b> This week, take note of your self-talk.
          Assess how you’re thinking about yourself, your
          spouse, and your marriage. Are you more positive?
          Negative? Talk to your spouse about your findings and
          commit to making any necessary changes.</p>
          </div>
        </div>
      </div>

      <style>
        .lesson-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          line-height: 1.6;
        }
        
        .intro-section, .handout-section, .closing-section {
          margin-bottom: 2rem;
        }
        
        .video-section {
          background: #f8f9fa;
          padding: 1rem;
          border-left: 4px solid #007bff;
          margin: 1rem 0;
        }
        
        .video-section a {
          color: #007bff;
          text-decoration: none;
          font-weight: bold;
        }
        
        .video-section a:hover {
          text-decoration: underline;
        }
        
        .questions-list {
          margin-top: 1rem;
        }
        
        .question-block {
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 1.5rem;
          margin-bottom: 1rem;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .question-block h4 {
          color: #495057;
          margin-bottom: 0.5rem;
          font-size: 1.1rem;
        }
        
        .question-block p {
          margin-bottom: 0;
          color: #6c757d;
        }
        
        .scripture-focus {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }
        
        .scripture-focus h4 {
          color: white;
        }
        
        .scripture-focus p {
          color: #f8f9fa;
        }
        
        .scripture-focus blockquote {
          background: rgba(255,255,255,0.1);
          border-left: 4px solid #ffd700;
          padding: 1rem;
          margin: 1rem 0;
          border-radius: 4px;
        }
        
        .scripture-focus blockquote p {
          color: white;
          font-style: italic;
          margin-bottom: 0;
          font-size: 1.1rem;
        }
        
        .prayer-section {
          background: #e8f5e8;
          padding: 1rem;
          border-radius: 8px;
          border-left: 4px solid #28a745;
        }
        
        .prayer-section p {
          margin-bottom: 0;
          font-style: italic;
          color: #155724;
        }
        
        h2 {
          color: #343a40;
          border-bottom: 2px solid #007bff;
          padding-bottom: 0.5rem;
        }
        
        h3 {
          color: #495057;
        }
      </style>
    `,
  },
  {
    id: 'practicing-safe-tech',
    title: 'Practicing Safe Tech',
    description:
      'Guarding your marriage in a digital world: healthy boundaries with phones, social media, and screens.',
    duration: '45 minutes',
    objectives: [],
    scriptureReferences: [],
    category: 'Other',
  },
];

export const getLessonById = (id: string): MarriageLesson | undefined => {
  return marriageLessons.find((lesson) => lesson.id === id);
};

export const getLessonsByCategory = (category: string): MarriageLesson[] => {
  return marriageLessons.filter((lesson) => lesson.category === category);
};
